module.exports = __webpack_public_path__ + "img/MS-Logo-Web.3f85e3ce.jpg";